import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginData } from 'src/app/models/loginData';
//import { ResetPasswordService } from 'src/app/services/reset-password.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})

export class ResetPasswordComponent implements OnInit {
  hide = true;
  LoginData: LoginData;
  loginlist: LoginData[];
  confirmpassword: any;

  constructor(private route: ActivatedRoute, private router: Router) {
    this.loginlist = [];
    this.LoginData = new LoginData();
    this.route.params.subscribe((res) => {
      this.LoginData.username = res['username'];
    }) 
  }
  ngOnInit(): void {
    const oldRecords = localStorage.getItem('loginlist');
    if (oldRecords !== null) {
      const loginlist = JSON.parse(oldRecords);
      const currentUser = loginlist.find((m: any) => m.username == this.LoginData.username);
      if (currentUser !== undefined) {
        this.LoginData.userid = currentUser.userid;
        this.LoginData.username = currentUser.username;
        this.LoginData.password = currentUser.password;
      }
    }
  }
  onSubmit() {
    if (this.LoginData.password === this.confirmpassword) {
      const oldRecords = localStorage.getItem('loginlist');
      if (oldRecords !== null) {
        const loginlist = JSON.parse(oldRecords);  
        loginlist.splice(loginlist.findIndex((a: any) => a.username == this.LoginData.username), 1);
        loginlist.push(this.LoginData);
        localStorage.setItem('loginlist', JSON.stringify(loginlist));
      }
      else {
        const userArr = [];
        userArr.push(this.LoginData);
        localStorage.setItem('loginlist', JSON.stringify(userArr));
      }
      this.router.navigate(['/login']);
    }
    else {
      alert("passsword and confirm password are not same");
    }
  }
}


